import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** One product (a gift set or bundle) as a large white card with its saving. */
export const schema: ComponentSchema = {
  type: 'combo-spotlight',
  label: 'Product spotlight',
  description: 'One product or gift set on a large card with its price, saving and Add to cart.',
  supportedPages: CONTENT_PAGES,
  variants: [{ id: 'v1', label: 'Large card' }],
  commonFields: [
    ...headingFields({ eyebrow: { en: 'Bundle & save', bn: 'একসাথে কিনে সাশ্রয়' }, title: { en: 'Gift set of the week', bn: 'এই সপ্তাহের গিফট সেট' } }),
    { key: 'productId', label: 'Product', type: 'product-select', help: 'Hidden until a product is picked.' },
    { key: 'description', label: 'Text', type: 'localized-text', default: { en: 'Everything for a happy birthday parcel, packed together for less.', bn: 'জন্মদিনের উপহারের সব কিছু, একসাথে কম দামে।' } },
    { key: 'mrpLabel', label: 'Regular price label', type: 'localized-string', default: { en: 'Regular price', bn: 'নিয়মিত দাম' } },
    { key: 'savingLabel', label: 'Saving label', type: 'localized-string', default: { en: 'You save', bn: 'আপনি বাঁচালেন' } },
    { key: 'detailsLabel', label: 'Details button text', type: 'localized-string', default: { en: 'View details', bn: 'বিস্তারিত দেখুন' } },
    ...SECTION_STYLE_FIELDS,
  ],
}
